import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ControllerComponent} from '../../../Controller/controller-component';
import {YuColorDto} from 'yukit';

@Component({
  selector: 'app-yu-custom-item',
  templateUrl: './yu-custom-item.component.html',
  styleUrls: ['./yu-custom-item.component.scss'],
  standalone: false
})
export class YuCustomItemComponent extends ControllerComponent {
  @Input() lines: string = 'none';
  @Input() isButton: boolean = false;
  @Input() isDisabled: boolean = false;

  @Input() showImage: boolean = false;
  @Input() image: string = '';

  @Input() icon: string = '';
  @Input() colorIcon: YuColorDto = 'primary';

  @Input() iconTitle: string = '';
  @Input() backgroundIconTitle: YuColorDto = 'medium';

  @Input() ranking?: number;

  @Input() title: string = '';
  @Input() description: string = '';

  @Input() cost?: number;
  @Input() quantity?: number;
  @Input() unit: string = '';

  @Input() extraData?: any;

  @Input() state: string = '';
  @Input() colorState: YuColorDto = 'primary';

  @Output() clickItem: EventEmitter<void> = new EventEmitter<void>();
}
